import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import './landing.css';
import { logo, subLogo, footerLogo } from '../../Assets/vacations';

const ArrowIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);

export const UnderConstruction = () => {
    useEffect(() => {
        document.title = 'Kayifi Vacations — Under Construction';
    }, []);

    return (
        <div className="vx-landing">
            <header className="site-header">
                <div className="container header-inner">
                    <div className="logo-cluster">
                        <a className="logo" href="https://kayifi.com"><img src={logo} alt="Kayifi" /></a>
                        <Link className="subdomain-btn" to="/" aria-current="page">Vacations</Link>
                    </div>
                    <Link className="sub-logo" to="/"><img src={subLogo} alt="Kayifi Vacations" /></Link>
                    <div className="header-actions">
                        <a className="nav-home" href="https://kayifi.com">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /></svg>
                            Home
                        </a>
                        <Link className="btn btn-ghost btn-sm" to="/login">Sign In</Link>
                        <Link className="btn btn-primary btn-sm" to="/sign-up">Register</Link>
                    </div>
                </div>
            </header>

            <main>
                <section className="uc-hero" aria-labelledby="uc-title">
                    <div className="container uc-inner">
                        <svg className="uc-roof" viewBox="0 0 100 20" aria-hidden="true"><polyline points="4,16 50,4.5 96,16" fill="none" stroke="#F8922D" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        <span className="eyebrow">vacations.kayifi.com</span>
                        <p className="uc-kicker">Something exciting is on the way</p>
                        <h1 id="uc-title">Under <span className="accent">Construction</span></h1>
                        <p className="uc-sub">We're building the Caribbean's home for villas, condos and getaways. Register now to be first in line, or sign in to your account.</p>
                        <div className="uc-actions">
                            <Link className="btn btn-primary btn-lg" to="/sign-up">Register <ArrowIcon /></Link>
                            <Link className="btn btn-outline-light btn-lg" to="/login">Sign In</Link>
                        </div>
                        <div className="uc-progress" role="img" aria-label="Site build in progress">
                            <div className="uc-progress-top"><span>Construction progress</span><b>Almost there</b></div>
                            <div className="uc-track"><div className="uc-bar" /></div>
                        </div>
                        <p className="uc-soon-label">Coming soon to Kayifi Vacations</p>
                        <ul className="chips-row">
                            <li className="chip">Villas</li>
                            <li className="chip">Condos</li>
                            <li className="chip">Beachfront Stays</li>
                            <li className="chip">Boutique Stays</li>
                        </ul>
                        <p className="chips-more">and many more…</p>
                    </div>
                </section>
            </main>

            <footer className="site-footer">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-brand">
                            <img src={footerLogo} alt="Kayifi Vacations" />
                            <p>vacations.kayifi.com — part of the Kayifi ecosystem. Your Tropical Connection.</p>
                        </div>
                        <div className="footer-col">
                            <h4>Kayifi Hub</h4>
                            <ul>
                                <li><a href="https://kayifi.com">Kayifi Home</a></li>
                                <li><a href="https://kayifi.com/en/properties">Properties</a></li>
                                <li><a href="https://services.kayifi.com/en">Services</a></li>
                                <li><a href="https://adventures.kayifi.com/en">Adventures</a></li>
                                <li><Link to="/">Vacations</Link></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Get In Touch</h4>
                            <ul>
                                <li><a href="mailto:info@kayifi.com">info@kayifi.com</a></li>
                                <li><Link to="/sign-up">Register</Link></li>
                                <li><Link to="/login">Sign In</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <p>© {new Date().getFullYear()} Kayifi. All rights reserved.</p>
                        <nav className="footer-links" aria-label="Kayifi network">
                            <a href="https://kayifi.com/en/properties">Properties</a>
                            <a href="https://services.kayifi.com/en">Services</a>
                            <a href="https://adventures.kayifi.com/en">Adventures</a>
                            <Link to="/">Vacations</Link>
                        </nav>
                    </div>
                </div>
            </footer>
        </div>
    );
};
